import { Typography, Card, CardContent, Divider, List } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Project } from 'api/models';
import { useRecoilState } from 'recoil';
import { projectState } from 'state/projectState';
import { getRoutePath } from 'utils';
import { RoutePaths } from 'types/types';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/system';

interface ProjectCardProps {
  project: Project;
}

export function ProjectCard({ project }: ProjectCardProps) {
  const [projectStore, setProjectState] = useRecoilState(projectState);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Card
      elevation={1}
      onClick={async () => {
        navigate(
          getRoutePath(RoutePaths.projectDashboard, {
            projectId: project.id,
          }),
        );
        setProjectState({
          ...projectStore,
          selectedProject: project,
        });
      }}
      sx={theme => {
        return {
          color: theme.palette.primary.contrastText,
          cursor: 'pointer',
          ':hover': {
            boxShadow: theme.shadows[3],
          },
          mr: 2,
          mt: 2,
          backgroundColor: theme.palette.primary.main,
        };
      }}
    >
      <CardContent>
        <Box display="flex" flexDirection={'row'} alignItems={'center'}>
          <Typography variant="h5" component="div">
            {project.name} -
          </Typography>
          <Typography variant="h5" sx={{ ml: 1 }} fontWeight={'bold'}>
            {project.shortName}
          </Typography>
        </Box>
        {project.description && <Divider sx={{ my: 1 }} />}
        {project.description && (
          <Box display="flex" flexDirection={'row'} alignItems={'center'}>
            <Typography fontWeight={'bold'}>
              {t(`projectCreation.description`)}:
            </Typography>
            <Typography sx={{ ml: 1 }}>{project.description}</Typography>
          </Box>
        )}

        {(project?.requiredPatientFields?.length ?? 0) > 0 && (
          <Divider sx={{ my: 1 }} />
        )}
        {/* in a list display required patient fields */}
        {(project?.requiredPatientFields?.length ?? 0) > 0 && (
          <Typography fontWeight={'bold'}>
            {t(`projectCreation.requiredPatientFields`)}:
          </Typography>
        )}
        <List sx={{ ml: 2 }}>
          {project?.requiredPatientFields?.map(field => (
            <Typography key={`required-patient-field-${field}`}>
              {t(`projectCreation.availablePatientFields.${field}`)}
            </Typography>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}
